/* eslint-disable */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import EPGForm from "../EPG/EPGForm";

export const ExportEPGReport = (props) => {

    const { onClose, isFromSchedule = false } = props;
    const navigate = useNavigate();
    const [footerMessage, setFooterMessage] = useState('');
    const lang = useTranslation();

    return (<>
        <BossDialog
            title={lang.export_report_dialog_header}
            onClose={onClose ? onClose : () => navigate('/home')}
            width={"650px"}
        >
            <EPGForm isPopup={true} isFromSchedule={isFromSchedule} item={{ date: props.date, channel: props.channel }} setFooterMessage={setFooterMessage} />
            <div className='text-right mt-3' style={{ position: 'fixed', height: '30px', width: '652px', marginLeft: '-20px', padding: '5px', background: "#3A3633" }}>
                <span style={{ color: 'white' }}>{footerMessage} </span>
            </div>
        </BossDialog>
    </>)
}
export default ExportEPGReport;